import React, { useEffect} from "react";

import $ from "jquery";
import "./Report.scss";
import ResultsSpider from "../../components/Spider/ResultsSpider";
import { connect } from "react-redux";
import { gsap } from "gsap";
//import ClipboardJS from "clipboard";
import Frame from "../../components/Frame/Frame";
import Gate from "./../../components/Gate/Gate";


import parse from 'html-react-parser';

import * as actionCreators from "../../store/actions/index";

import jsonData from "./report.json";
import content from "../../libs/jsonParsers/content.json";
import DynamicAssets from "../../components/DynamicAssets/DynamicAssets";
let totalPossible = 24;

//animations
let total = 0;
let TotalScore = 0;

let currentLabel = "";
let labelArray = [];
let lablName = labelArray[0];

const Report = (props) => {
  const demoHanldr = () => {
    props.onToggleDemo();
  };

  $("html").addClass("show");
  const search = window.location.search;
  const searchURL = window.location.search;
  const params = new URLSearchParams(search);
  let gateOff = params.get("gateoff");
  let linkedInSearchURL = searchURL.replace(/\b(=)\b/g, (match) => "%3D");
  linkedInSearchURL = linkedInSearchURL.replace(/\b(&)\b/g, (match) => "%26");
  const labelArray = props.currentLabels;
  //const report = params.get("report");
  //const score=params.get("score");

  const showGate = gateOff ? null : <Gate />;

  let lastLabl = 0;
  let currLabel = 0;
  let loc=window.location;


  useEffect(() => {
    console.log(" gateOff: " +  gateOff)

    props.onChooseQuestions(props.role, "English");
    props.onInitScores(props.scrs);
    totalPossible = props.scrs.length * 4;
    $('#eloqua-pop').magnificPopup();
    function updateSummary() {

      $("#executive-summary").html("");
      let summary_content = "";
      var summary_level = jsonData.summary[0].low;

      if (TotalScore > 11) {
        summary_level = jsonData.summary[0].med;
        if (TotalScore > 18) {
          summary_level = jsonData.summary[0]["med-high"];
          if (TotalScore > 23) {
            summary_level = jsonData.summary[0].high;
          }
        }
      }
      $.each(summary_level, function (index, value) {
        summary_content += value;
      });

      $("#executive-summary").append(summary_content);
     // new ClipboardJS(".copy-btn");
      currentLabel = $("dynamic-content-label-0").text();

    }
    for (var i = 0; i < props.scrs.length; i++) {
      //const ans_temp = ANSWERS_MAP[props.scrs[i]];
      const ans_temp = props.scrs[i];
      total += ans_temp;
      TotalScore = total;

      if (i === props.scrs.length - 1) {
        setTimeout(function () {
        
          const obj = document.getElementById("user-score");
          arrangeElements();
          updateSummary();
          cloudAnimations();
          animateNumbers(obj, 0, TotalScore, 1500);
          $(".dynamic-content-text-0").height(
            $(".dynamic-content-text--1-0").height()
          );
        }, 1000);
      }
    }
  }, []);

  window.onresize = arrangeElements;

  function arrangeElements() {
    if (window.innerWidth < 1025) {
      $(".cloud-animation").detach().appendTo(".mobile-cloud-holder");
      $(".report-section-graph").detach().appendTo(".mobile-spider-holder");
      $(".report-section-footer-content")
        .detach()
        .appendTo(".report-section-footer .report__content");
    } else {
      $(".report-section-graph")
        .detach()
        .appendTo(".report-section-spider .report__content-right");
      $(".social-links")
        .detach()
        .appendTo(".report-section-footer .report__content");
      $(".cloud-animation")
        .detach()
        .appendTo(".report-section-hero .report__content-right");
    }
  }
  function confirmCopy() {
    $(".next-step-confirm").addClass("visible");
    setTimeout(function () {
      $(".next-step-confirm").removeClass("visible");
    }, 1000);
  }
  function mailHandler(){
    let email= localStorage.getItem('email');
    let link=encodeURIComponent(loc)+"%26gateoff=true"
    window.open("mailto:"+email+"?subject=SAP%20cloud%20migration%20assessment%20results&body=Hi%2C%0A%0AThank%20you%20for%20completing%20the%20SAP%20cloud%20migration%20assessment.%0A%0AHere%20is%20the%20link%20to%20your%20result%20report%3A%20" + link+".%0A%0AYou%20can%20check%20out%20the%20assessment%20again%20at%20https%3A%2F%2Fwww.oracle.com%2Fwebfolder%2Fs%2Fassets%2Fassessment-tool%2Fsap-cloud-migration%2Findex.html.%0A%0AHere%20is%20the%20report%20on%20a%20similar%20survey%20where%20we%20derive%20the%20peer%20comparison%3A%20https%3A%2F%2Fwww.oracle.com%2Fa%2Focom%2Fdocs%2Fapplications%2Ferp%2Fpac-sap-s4hana-migration-maturity-model-inbrief-analysis.pdf.","_blank")
}
  function cloudAnimations() {
    var h = 209;
    if (window.innerWidth < 1024) {
      h = 120.3;
    }
    totalPossible = props.scrs.length * 4;
    let backgroundHeight = (TotalScore / totalPossible) * h;
    let cloudHeight = (backgroundHeight / h) * 100;
    $("#cloud-anim-background").css("height", cloudHeight + "%");
    $("#numbers-holder").css("bottom", backgroundHeight + "px");
  }

  function animateNumbers(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const isGate = () =>{
    if (gateOff === 'true'){
      return;
    } 
    else{
      return  <Frame></Frame>;
    }

  }

  const spiderLabelClickHandlr = (lablName) => {
    lastLabl = currLabel;
    currLabel = labelArray.indexOf(lablName) + 1;
    const changeLabel = () => {
      $(".dynamic-content-label-0").text(lablName);
      currentLabel = lablName;
    };

    const checkHeight = () => {
      $(".dynamic-content-text-0").height(
        $(".dynamic-content-text--1-0").height()
      );
    };
    gsap.to(`.dynamic-content-label-${lastLabl}`, {
      opacity: 0,
      x: 10,
      duration: 0.5,
      onComplete: changeLabel,
    });

    gsap.to(`.dynamic-content-text-${lastLabl}`, {
      opacity: 0,
      x: 10,
      zIndex:0,
      duration: 0.5,
    });

    gsap
      .to(`.dynamic-content-label-${currLabel}`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
      })
      .delay(0.75);

    gsap
      .to(`.dynamic-content-text-${currLabel}`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
        zIndex:10,
        onStart: checkHeight,
      })
      .delay(0.75);
  };

  const dynamixTxtContentCap = () => {
    if (!props.currentLabels[0]) return <div>Loading...</div>;

    const retThis0 = [
      <React.Fragment>
        {isGate()}

       
        <div
          className={`dynamic-content-label dynamic-content-label-${0}`}
          id="dynamic-label"
          key={`d1-${0}`}
        >
          {props.currentLabels[0]}
        </div>
        <div
          className={`dynamic-content-text dynamic-content-text-${0}`}
          key={`d2-${0}`}
        >
          {}
          <div
            className={`dynamic-content-text--1 dynamic-content-text--1-${0}`}
            key={`d3-${0}`}
          >
            <p>
              {content.Report.Dynamic[props.role][props.currentLabels[0]].first}
            </p>
            <p>
            {content.Report.Dynamic[props.role][props.currentLabels[0]].second}

            </p>
          </div>
        </div>
        <div
          className="dynamic-content-hr dynamic-content-hr-0"
          key={`d4-${0}`}
        ></div>
      </React.Fragment>,
    ];

    const retThis1 = props.currentLabels.map((e, i) => {
      if (!props.currentLabels[i]) {
        return <div>Loading...</div>;
      }
      let ptwo= (JSON.stringify(content.Report.Dynamic[props.role][props.currentLabels[i]].second))

      ptwo=ptwo.replace(/['"]+/g, '')
      return (
        <React.Fragment>
          <div
            className={`dynamic-content-label dynamic-content-label-${i + 1}`}
            id="dynamic-label"
            key={`d1-${i + 1}`}
          >
            {props.currentLabels[i]}
          </div>
          <div
            className={`dynamic-content-text dynamic-content-text-${i + 1}`}
            key={`d2-${i + 1}`}
          >
            <div
              className={`dynamic-content-text--1 dynamic-content-text--1-${
                i + 1
              }`}
              key={`d3-${i + 1}`}
            >
              <p>
                {
                  content.Report.Dynamic[props.role][props.currentLabels[i]]
                    .first
                }
              </p>
              <p>
                {
                parse(ptwo)
                }
              </p>
            </div>
          </div>
        </React.Fragment>
      );
    });

    return retThis0.concat(retThis1);


  };
  return (
    <div className="report-holder">
      <div className="report ">
        <section className="report-section report-section-hero">
          <div className="report__content ">
            <div className="report__content-left">
              <div className="report-section-hero-logo"></div>
              <h3>RESULTS REPORT</h3>
              <hr className="Landing__hr"></hr>
              <h1 className="Landing__title">
                Cloud Applications for the Digital Era
              </h1>
              <div className="mobile-cloud-holder"></div>
              <div id="executive-summary"></div>
            </div>
            <div className="report__content-right relative">
              <div className="cloud-animation">
                <div className="cloud-animation-numbers" id="numbers-holder">
                  <div className="cloud-animation-number" id="user-score"></div>
                  <div className="cloud-animation-number">/{totalPossible}</div>
                </div>
                <div
                  className="cloud-animation-image-2"
                  id="cloud-anim-background"
                ></div>
                <div className="cloud-animation-image-1"></div>
                <div className="cloud-animation-label">
                Your overall cloud applications maturity score
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="report-section report-section-spider">
          <div className="report__content">
            <div className="report__content-left">
              <div className="report-section-header">
                <h3>Capabilities and resources</h3>
                <p className="gen-cap">
                According to <a href="https://www.bcg.com/publications/2022/innovation-in-climate-and-sustainability-will-lead-to-green-growth" target="_blank">Boston Consulting Group</a>, Oracle is the 19th most innovative company in the world across all industries. The same research shows that SAP ranked 40th, down 13 places compared to last year. The same study revealed that most innovative companies outperformed the broader market on shareholder return by 5.6 percent.
                </p>
                <p className="gen-cap">
                  {content.Report.General.second}
                </p>
     <div className="dynamic-content">{dynamixTxtContentCap()}</div>
                <DynamicAssets role={props.role} />
              </div>

              <div className="mobile-spider-holder"></div>
         
            </div>

            <div className="report__content-right">
              <div className="report-section-graph">
                <ResultsSpider
                  spdrlblclick={spiderLabelClickHandlr}
                  labelArray={props.currentLabels}
                />
              </div>
            </div>
          </div>
        </section>
        <section className="report-section report-section-summary">
          <div className="report__content">
            <div className="report__content-left">
              <h3 className="report-section-header">
                Summary and next steps
              </h3>
              <div className="report-section-summary-content">
                <p>Cloud applications are all about supporting innovation.</p>
                <p>
                At Oracle, we believe that the cloud offers more than a switch from CapEx to OpEx. In fact, we talk about software as a service (SaaS) with the emphasis on service. The service that Oracle delivers with our SaaS applications is about supporting faster innovation at your company. With Oracle Cloud Applications, you no longer have to worry about the outdated technology holding your business back. You get new capabilities that automate the processes that are slowing you down, along with new insights to make better decisions.
                </p>
                <p>
                  Find out what{" "}
                  <a
                    href="https://www.oracle.com/erp/move-on-premises-to-cloud/"
                    target="_blank"
                  >
                    Oracle Fusion Cloud ERP
                  </a>{" "}
                  has to offer. If you are an existing SAP customer and you want
                  to know more about how to move from SAP to Oracle Cloud ERP,
                  see{" "}
                  <a
                    href="https://www.oracle.com/erp/move-on-premises-to-cloud/"
                    target="_blank"
                  >
                    https://www.oracle.com/erp/move-on-premises-to-cloud/
                  </a>
                  . To find out how Oracle SaaS supports innovation, see{" "}
                  <a
                    href="https://www.erp.com/post-detail/erp-is-the-new-innovation-platform"
                    target="_blank"
                  >
                    Why SaaS ERP is the new innovation platform for business
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="report__content-right">
              <div className="next-steps">
                <div className="next-step next-step-left">
                  <div className="next-step-icon next-step-icon-demo"></div>
                  <div className="next-step-label">Request a demo</div>
                  <div className="next-step-text cheat-wide">
                    See what Oracle Cloud ERP can do for you.{" "}
                  </div>
                  <a
                    className="next-step-btn"
                    href="https://www.oracle.com/erp-demo-form.html?qt=saas_erp_fam"
                    target="_blank"
                    tabIndex='1'
                  >
                    See a demo
                  </a>
                </div>

                <div className="next-step next-step-top ">
                  <div className="next-step-icon next-step-icon-tour"></div>
                  <div className="next-step-label">Take a tour</div>
                  <div className="next-step-text">
                    Explore Oracle Cloud <br /> ERP applications
                  </div>
                  <a
                    className="next-step-btn"
                    href="https://www.oracle.com/erp/product-tours/"
                    target="_blank"
                    tabIndex='1'
                  >
                    Browse tours
                  </a>
                </div>

                <div className="next-step next-step-left">
                  <div className="next-step-icon next-step-icon-email"></div>
                  <div className="next-step-label">Share the report</div>
                  <div className="next-step-text">
                  Email this report to yourself and your colleagues
                  </div>
                  <button
                  className="next-step-btn email-btn"
                  onClick={mailHandler}
                  tabIndex="1"
                >
                Email the report</button>
                </div>

                <div className="next-step">
                  <div className="next-step-icon next-step-icon-contact"></div>
                  <div className="next-step-label">Contact us</div>
                  <div className="next-step-text cheat-wide">
                    Learn what Oracle Cloud ERP can do for you.
                  </div>
                  <a
                    className="next-step-btn"
                    href="https://www.oracle.com/applications/erp/contact-form.html"
                    target="_blank"
                    tabIndex='1'
                  >
                    Contact us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="report-section report-section-footer">
          <div className="report__content">
            <div className="report-section-footer-content">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.oracle.com/legal/privacy/"
                className="report-section-footer-link"
              >
                © 2022 Oracle
              </a>
              <span className="Footer__line"></span>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.oracle.com/legal/privacy/"
                className="report-section-footer-link"
              >
                Privacy/Do Not Sell My Info
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                id="teconsent"
                className="report-section-footer-link"
              ></a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising"
                className="report-section-footer-link last-link"
              >
                Ad Choices
              </a>
            </div>
            <div className="social-links">
              <a
                rel="noreferrer"
                href={`: https://www.linkedin.com/company/oracle `}
                className="Socials__icon Socials__icon--4"
                target="_blank"
              ></a>
              <a
                rel="noreferrer"
                href={`https://twitter.com/oraclecloudERP`}
                className="Socials__icon Socials__icon--3"
                target="_blank"
              ></a>
              <a
                rel="noreferrer"
                href={`https://www.facebook.com/OracleCloudERP`}
                target="_blank"
                className="Socials__icon Socials__icon--2"
              ></a>
            </div>
            <div className="o-tag"></div>
          </div>
        </section>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChooseQuestions: (role, lang) =>
      dispatch(actionCreators.choose_questions(role, lang)),
    onInitScores: (scrz) => dispatch(actionCreators.init_scores(scrz)),
    onToggleDemo: () => dispatch(actionCreators.toggle_demo()),
  };
};

const mapStateToProps = (state) => {
  return {
    currentLabels: state.questionsReducer.currentLabels,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);
